export default (node, name) => {
  const newNode = document.createElement(name);
  Array.prototype.slice.call(node.attributes).forEach(function(a) {
    newNode.setAttribute(a.nodeName, a.nodeValue);
  });
  while (node.firstChild) {
    newNode.appendChild(node.firstChild);
  }
  return node.parentNode.replaceChild(newNode, node);
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/util/renameElement.js